import request from './request'
import {
    QueryPageDto,
    QueryDateSlotDto
} from './dto'
// RechargeRecord
export interface RechargeRecordDto extends QueryPageDto, QueryDateSlotDto {
    exportType?: string
}
export interface ResultRechargeRecordDto {
    amount: number
    successTime: string
    status?: string | undefined
}

export interface SeatRecordDto {
    /**
     * accountExpireTime
     */
    accountExpireTime?: string;
    /**
     * 公司id
     */
    companyId?: number;
    /**
     * 客户名称
     */
    companyName?: string;
    /**
     * 生效时间
     */
    createTime?: string;
    /**
     * 支付金额
     */
    payMoney?: number;
    /**
     * 支付时间
     */
    payDate?: string;

    voucherUrl?: string;
    /**
     * 支付方式
     */
    payMode?: number;
    updateUserId?: number;
    /**
     * 状态
     */
    status?: number;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 订单id
     */
    id?: number;
    /**
     * 订单号
     */
    receiptId?: number;
    /**
     * 订单金额
     */
    /**
     * 席位数
     */
    buySeatCount?: number;
    /**
     * 过期时间
     */
    dueDate?: string;
    /**
     * 类型（1：赠送，2购买）
     */
    salesScenario?: number;
    /**
     * 生效时间
     */
    updateTime?: string;
    [property: string]: any;
}

/**
 * 席位购买记录
 */
export interface SeatList {
    hasNextPage: boolean;
    list: SeatRecordDto[];
    total: number;
    [property: string]: any;
}

export interface CompanySeatInfoDto {
    /**
     * 团队账号过期时间
     */
    accountExpireTime: string;
    /**
     * 公司id
     */
    companyId: number;
    /**
     * 客户名称
     */
    companyName: string;
    /**
     * 即将到期席位数量
     */
    expireSeatsCount: number;
    /**
     * 拥有席位数
     */
    hasSeat: number;
    /**
     * 席位购买记录
     */
    seatList: SeatList;
    /**
     * 生效时间
     */
    updateTime: null;
    /**
     * 已使用席位数
     */
    useSeat: number;
    [property: string]: any;
}

// 投保充值记录
export function insureRechargeRecord(params: RechargeRecordDto): Promise<{ total: number, list: ResultRechargeRecordDto[] }> {
    return request.get('/rest/insure/insure-info/insure-recharge-record', {
        params
    })
}

// 电子签记录
export function elesignRechargeRecord(params: RechargeRecordDto): Promise<{ total: number, list: ResultRechargeRecordDto[] }> {
    return request.get('/rest/elesign/ele-sign-contract-record/elesign-recharge-record', {
        params
    })
}

// 发薪记录 rest/pay/recharge/record/list

export function getPayList(params: RechargeRecordDto): Promise<{ total: number, list: ResultRechargeRecordDto[] }> {
    return request.get('/rest/pay/recharge/record/list', {
        params
    })
}

// 获取团队账户信息
export function getRechargeList(params: QueryPageDto): Promise<{ totalCount: number, list: ResultRechargeRecordDto[] }> {
    return request.get('/saas/note/saasCompany/recharge-record', {
        params
    })
}

// 获取订单信息
export function getCompanySeatInfo(params: QueryPageDto): Promise<CompanySeatInfoDto> {
    return request.get('/pay/pay-company-seat/company-seat-info', {
        params
    })
}

// 续费 + 购买席位
export function addRechargeRecord(data: any): Promise<ResultRechargeRecordDto[]> {
    return request.post('/saas/note/saasCompany/add-recharge-record', data)
}

// 同步某公司某天的发薪充值记录
export function syncPayRecharge(params: { companyId: string; queryDay: string }): Promise<any> {
    return request.get('/saas/recharge/record/sync-recharge', {
        params
    })
}
